import { NgIf } from '@angular/common';
import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { HomepageService } from '@app/_services/homepage.service';
import { SharedService } from '@app/_services/shared.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { RootService } from '@services/root.service';
import { ProductsViewComponent } from '../../_components/products-view/products-view.component';
import { ShopSidebarComponent } from '../../_components/shop-sidebar/shop-sidebar.component';
import { WidgetAdvancedSearchComponent } from '../widget-advanced-search/widget-advanced-search.component';

@UntilDestroy()
@Component({
    selector: 'app-block-category',
    templateUrl: './block-category.component.html',
    styleUrls: ['./block-category.component.scss'],
    standalone: true,
    imports: [NgIf, WidgetAdvancedSearchComponent, ShopSidebarComponent, ProductsViewComponent]
})
export class BlockCategoryComponent implements OnInit, OnDestroy, OnChanges {
    @Input() categoryData;
    @Input() sidebarPosition;
    @Input() columns;
    @Input() filtersData;
    @Input() products;
    @Input() filterParams;
    @Input() categorySlug;
    @Input() productsCount;
    @Input() viewMode;
    @Input() parent;
    @Input() showSidebar = 'true';

    sector;
    view;
    constructor(
        public root: RootService, private sharedService: SharedService, private homepageService: HomepageService

    ) {

    }

    ngOnDestroy(): void {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.categoryData?.currentValue) {
            const mainCategory = this.homepageService.getMainCategory(this.categoryData);
            this.view = mainCategory?.view || 'default';
        }
    }

    ngOnInit(): void {

    }
}

